<template>
  <v-overlay :value="show" absolute opacity="0.85" z-index="100" color="#000">
    <v-card
      class="text-center rounded-xl pa-5 mx-auto popup-card"
      width="280"
      light
      elevation="10"
    >
      <!-- آیکون وضعیت -->
      <div class="icon-wrapper mx-auto mb-4" :class="type">
        <v-icon size="40" :color="iconColor">{{ iconName }}</v-icon>
      </div>

      <!-- زمان -->
      <h2 class="mb-2 text-h4 font-weight-black time-text" dir="ltr" v-if="time">
        {{ time }}
      </h2>

      <!-- عنوان و پیام -->
      <h3 class="mb-2 font-weight-bold" :class="textColor">{{ title }}</h3>
      <p class="text-body-2 grey--text text--darken-2 mb-6">
        {{ message }}
      </p>

      <v-btn
        :color="iconColor"
        class="rounded-lg white--text"
        block
        depressed
        @click="$emit('close')"
      >
        متوجه شدم
      </v-btn>
    </v-card>
  </v-overlay>
</template>

<script>
export default {
  name: "AttendanceFeedbackPopup",
  props: {
    show: Boolean,
    type: { type: String, default: "success" }, // success, error, warning
    title: String,
    message: String,
    time: String,
  },
  computed: {
    iconName() {
      if (this.type === "success") return "mdi-check-circle-outline";
      if (this.type === "error") return "mdi-close-circle-outline";
      return "mdi-alert-circle-outline";
    },
    iconColor() {
      if (this.type === "success") return "green darken-1";
      if (this.type === "error") return "red darken-1";
      return "orange darken-1";
    },
    textColor() {
      if (this.type === "success") return "green--text text--darken-2";
      if (this.type === "error") return "red--text text--darken-2";
      return "orange--text text--darken-2";
    },
  },
};
</script>

<style scoped>
.popup-card {
  background: white !important;
  animation: scale-in 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}
.icon-wrapper {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.icon-wrapper.success { background-color: #e8f5e9; }
.icon-wrapper.error { background-color: #ffebee; }
.icon-wrapper.warning { background-color: #fff3e0; }

.time-text { letter-spacing: 2px; }

@keyframes scale-in {
  0% { transform: scale(0.8); opacity: 0; }
  100% { transform: scale(1); opacity: 1; }
}
</style>
